var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"mask"},[_c('div',{staticClass:"container"},[_vm._t("title",function(){return [(_vm.title)?_c('b-row',{staticClass:"pb-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1):_vm._e()]}),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }